import {Text} from 'platform/foundation';

import i18n from '@dms/i18n';

import {VehicleForm as VFKit} from '../../kit/VehicleForm';

export function ServiceInspectionSubSection() {
  return (
    <VFKit.SubSection
      data-testid="service-inspection-section"
      title={i18n.t('entity.vehicle.labels.serviceInspection')}
      useCard
    >
      <Text color="secondary" size="xSmall">
        {i18n.t('entity.vehicle.labels.serviceInspectionDescription')}
      </Text>
      <VFKit.Group data-testid="service-inspection-fields" columns={[1, 2, 4]}>
        <VFKit.LastServiceDatePicker />
        <VFKit.SimpleNumericField name="lastServiceMileage" />
        <VFKit.NextServiceDatePicker />
        <VFKit.SimpleNumericField name="nextServiceMileage" />
      </VFKit.Group>
    </VFKit.SubSection>
  );
}
